var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateTreeCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 162,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M1 0h316v111H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.317 103.732c0 .233-.011.464-.033.691a7.063 7.063 0 0110.903 2.632 7.063 7.063 0 0112.992-1.386 7.06 7.06 0 0112.975-3.091 7.024 7.024 0 012.876-.611c1.472 0 2.838.45 3.969 1.22a7.03 7.03 0 013.969-1.22c2.111 0 4.006.926 5.3 2.395a7.059 7.059 0 017.055-6.807 7.064 7.064 0 016.859 5.378 7.062 7.062 0 017.544 4.117 7.062 7.062 0 0112.957-1.444 7.082 7.082 0 013.688-3.188 7.062 7.062 0 0112.058 3.448 7.06 7.06 0 0112.629 0 7.062 7.062 0 0113.536-1.078 7.04 7.04 0 014.86-1.939 7.058 7.058 0 016.142 3.577 4.407 4.407 0 013.565-1.812 4.4 4.4 0 013.289 1.471 7.058 7.058 0 016.419-4.118c1.204 0 2.337.301 3.329.832a7.037 7.037 0 014.613-1.715c2.179 0 4.128.988 5.423 2.539a7.062 7.062 0 0112.901 1.925 4.397 4.397 0 012.187 1.002 7.084 7.084 0 014.897.67 7.045 7.045 0 015.478-2.606 7.049 7.049 0 015.709 2.907 7.06 7.06 0 0113.706 2.388h.001v30.004H.183v-30.004a7.06 7.06 0 018.77-6.851 7.06 7.06 0 0113.247 2.528 7.024 7.024 0 013.578-.972c2.123 0 4.027.937 5.321 2.42a7.06 7.06 0 0113.624-3.183c.31.058.614.136.91.233a7.044 7.044 0 012.208-.353c1.302 0 2.522.353 3.57.968a7.06 7.06 0 0114.065.424 7.076 7.076 0 014.2 4.786h1.16a7.061 7.061 0 018.09-6.095 7.063 7.063 0 0111.982-3.173 7.06 7.06 0 0113.409 3.091zm24.656 6.177l.019-.172c.031.058.063.115.096.172h-.115z",
    fill: "#57935A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.724 132.145c2.346 0 4.248-.179 4.248-.401 0-.222-1.902-.401-4.248-.401s-4.247.179-4.247.401c0 .222 1.901.401 4.247.401z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.684 117.212h-1.836v14.399h1.837v-14.399z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.765 109.912a6.635 6.635 0 00-6.632 6.638 6.635 6.635 0 006.632 6.637v-13.275z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.715 123.184a6.635 6.635 0 006.632-6.637 6.635 6.635 0 00-6.632-6.638v13.275z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.188 127.733c1.601 0 2.899-.122 2.899-.274 0-.151-1.298-.273-2.899-.273s-2.899.122-2.899.273c0 .152 1.298.274 2.899.274z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.851 117.54h-1.253v9.828h1.253v-9.828z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.222 112.559a4.529 4.529 0 00-4.527 4.53 4.529 4.529 0 004.527 4.53v-9.06z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.191 121.617c2.5 0 4.527-2.028 4.527-4.53a4.529 4.529 0 00-4.527-4.53v9.06z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.657 133.911c1.601 0 2.899-.123 2.899-.274 0-.151-1.298-.274-2.899-.274s-2.899.123-2.899.274c0 .151 1.298.274 2.899.274z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.32 123.718h-1.254v9.827h1.254v-9.827z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.691 118.736a4.53 4.53 0 00-4.527 4.53 4.53 4.53 0 004.527 4.531v-9.061z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.66 127.795a4.53 4.53 0 004.527-4.53 4.53 4.53 0 00-4.527-4.531v9.061z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.88 125.969c1.601 0 2.899-.123 2.899-.274 0-.151-1.298-.274-2.899-.274-1.602 0-2.9.123-2.9.274 0 .151 1.298.274 2.9.274z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.543 115.775h-1.254v9.828h1.254v-9.828z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.913 110.794a4.528 4.528 0 00-4.526 4.53 4.528 4.528 0 004.526 4.53v-9.06z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.883 119.852c2.5 0 4.527-2.028 4.527-4.53a4.529 4.529 0 00-4.527-4.53v9.06z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.251 128.616c1.601 0 2.899-.122 2.899-.274 0-.151-1.298-.274-2.899-.274s-2.899.123-2.899.274c0 .152 1.298.274 2.899.274z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.914 118.423h-1.254v9.828h1.254v-9.828z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.285 113.441a4.53 4.53 0 00-4.527 4.531 4.53 4.53 0 004.527 4.53v-9.061z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.254 122.5a4.53 4.53 0 004.527-4.53 4.53 4.53 0 00-4.527-4.531v9.061z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75 121.556c1.602 0 2.9-.123 2.9-.274 0-.152-1.298-.274-2.9-.274-1.6 0-2.898.122-2.898.274 0 .151 1.297.274 2.899.274z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.414 111.362H86.16v9.828h1.254v-9.828z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.784 106.381a4.528 4.528 0 00-4.526 4.53 4.528 4.528 0 004.526 4.53v-9.06z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.754 115.439c2.5 0 4.527-2.028 4.527-4.53a4.528 4.528 0 00-4.527-4.53v9.06z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.106 123.321c1.601 0 2.899-.122 2.899-.274 0-.151-1.298-.274-2.899-.274s-2.899.123-2.899.274c0 .152 1.298.274 2.899.274z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.769 113.128h-1.253v9.828h1.253v-9.828z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14 108.146a4.53 4.53 0 00-4.527 4.531 4.529 4.529 0 004.527 4.53v-9.061z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.109 117.205c2.5 0 4.527-2.028 4.527-4.53a4.529 4.529 0 00-4.527-4.53v9.06z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.622 134.794c1.6 0 2.899-.123 2.899-.274 0-.151-1.298-.274-2.9-.274-1.6 0-2.898.123-2.898.274 0 .151 1.298.274 2.899.274z",
    fill: "#284D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.285 124.601H12.03v9.827h1.254v-9.827z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.656 119.619a4.528 4.528 0 00-4.527 4.53 4.528 4.528 0 004.527 4.53v-9.06z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 128.677c2.5 0 4.527-2.028 4.527-4.53a4.528 4.528 0 00-4.527-4.53v9.06z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 133.75S57.901 118 98.864 118s116.398 20.575 116.398 20.575S281.399 120.749 318 120.749V168H1v-34.25z",
    fill: "#74BB49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.268 129.498c4.301 0 7.788-.329 7.788-.736 0-.406-3.487-.736-7.788-.736-4.3 0-7.788.33-7.788.736 0 .407 3.487.736 7.788.736z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.032 102.118h-3.368v26.4h3.368v-26.4z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.352 88.733c-6.716 0-12.16 5.449-12.16 12.17s5.444 12.169 12.16 12.169V88.733z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.266 113.068c6.715 0 12.16-5.448 12.16-12.169s-5.445-12.17-12.16-12.17v24.339z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.084 122.437c2.346 0 4.247-.179 4.247-.401 0-.222-1.901-.401-4.247-.401s-4.248.179-4.248.401c0 .222 1.902.401 4.248.401z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.044 107.504h-1.837v14.399h1.837v-14.399z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.125 100.204a6.635 6.635 0 00-6.633 6.638 6.635 6.635 0 006.633 6.637v-13.275z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.074 113.476a6.635 6.635 0 006.633-6.637 6.635 6.635 0 00-6.633-6.638v13.275z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.029 123.32c2.346 0 4.248-.179 4.248-.401 0-.222-1.902-.401-4.248-.401s-4.248.179-4.248.401c0 .222 1.902.401 4.248.401z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.989 108.387h-1.837v14.399h1.837v-14.399z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.07 101.087a6.635 6.635 0 00-6.632 6.637 6.635 6.635 0 006.632 6.638v-13.275z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.02 114.359a6.636 6.636 0 006.632-6.638 6.635 6.635 0 00-6.632-6.637v13.275z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.968 136.98c7.045 0 12.757-.54 12.757-1.205 0-.666-5.712-1.206-12.757-1.206-7.046 0-12.757.54-12.757 1.206 0 .665 5.711 1.205 12.757 1.205z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86 92.129h-5.516v43.245h5.516V92.129z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.145 71.963C9.423 71.963.73 80.458.73 90.936c0 10.479 8.693 18.974 19.415 18.974V71.963z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.145 109.91c10.234 0 18.532-8.495 18.532-18.974 0-10.478-8.298-18.973-18.532-18.973v37.947z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.623 122.438c5.325 0 9.642-.408 9.642-.911 0-.503-4.317-.911-9.642-.911-5.326 0-9.642.408-9.642.911 0 .503 4.316.911 9.642.911z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.814 88.54h-4.17v32.685h4.17V88.539z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.727 71.968c-8.314 0-15.055 6.746-15.055 15.067 0 8.32 6.74 15.067 15.055 15.067V71.968z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.617 102.097c8.315 0 15.056-6.746 15.056-15.067s-6.741-15.067-15.056-15.067v30.134z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.635 145.834c13.563 0 24.557-1.039 24.557-2.32 0-1.282-10.994-2.321-24.557-2.321-13.562 0-24.557 1.039-24.557 2.321 0 1.281 10.995 2.32 24.557 2.32z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.213 59.496h-10.62v83.248h10.62V59.496z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.907 17.287c-21.177 0-38.344 17.181-38.344 38.374S42.73 94.035 63.907 94.035V17.287z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.637 94.026c21.176 0 38.344-17.181 38.344-38.374S84.813 17.278 63.637 17.278v76.748z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.362 134.332c8.815 0 15.96-.675 15.96-1.508 0-.832-7.145-1.508-15.96-1.508-8.814 0-15.96.676-15.96 1.508 0 .833 7.146 1.508 15.96 1.508z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.984 78.22h-6.902v54.103h6.902V78.22z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.534 50.79c-13.763 0-24.921 11.166-24.921 24.94 0 13.773 11.158 24.939 24.921 24.939V50.79z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.359 100.662c13.763 0 24.921-11.166 24.921-24.94 0-13.773-11.158-24.939-24.921-24.939v49.879z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.887 139.232c11.007 0 19.93-.843 19.93-1.883s-8.923-1.883-19.93-1.883-19.93.843-19.93 1.883 8.923 1.883 19.93 1.883z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.411 69.161h-8.618v67.563h8.618V69.161z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.104 34.906c-17.186 0-31.12 13.944-31.12 31.144 0 17.2 13.934 31.143 31.12 31.143V34.906z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.883 97.185c17.186 0 31.12-13.944 31.12-31.143 0-17.2-13.934-31.144-31.12-31.144v62.287z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.703 153.151c5.849 0 10.59-.79 10.59-1.765 0-.975-4.741-1.765-10.59-1.765-5.848 0-10.59.79-10.59 1.765 0 .975 4.742 1.765 10.59 1.765zM189.58 160.211c8.773 0 15.885-1.58 15.885-3.53 0-1.949-7.112-3.53-15.885-3.53s-15.885 1.581-15.885 3.53c0 1.95 7.112 3.53 15.885 3.53z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.483 89.188h-1.671v53.93h1.671v-53.93z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.74 84.317c-7.612 0-13.779 6.173-13.779 13.79 0 7.616 6.167 13.789 13.779 13.789V84.317z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.645 111.902c7.611 0 13.778-6.172 13.778-13.789s-6.167-13.789-13.778-13.789v27.578z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.004 148.035l-2.494-7.42c-.476-1.407-1.783-2.512-3.446-3.056a.887.887 0 00.121-.167l1.043-1.944c.264-.491-.522-.975-1.588-.975h-3.786c-1.073 0-1.852.484-1.587.975l1.05 1.944c.03.053.068.106.114.159-1.678.545-3.001 1.649-3.47 3.071l-2.471 7.42c-.628 1.891 1.232 3.729 3.771 3.729h8.979c2.54-.007 4.399-1.845 3.764-3.736z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.036 162.572c23.524 0 42.595-1.802 42.595-4.025 0-2.223-19.07-4.025-42.595-4.025-23.524 0-42.595 1.802-42.595 4.025 0 2.223 19.07 4.025 42.595 4.025z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.712 12.816H-8.707v144.395h18.42V12.816z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.509-60.395C-36.222-60.395-66-30.594-66 6.166c0 36.76 29.778 66.56 66.509 66.56v-133.12z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.043 72.71c36.731 0 66.509-29.801 66.509-66.56 0-36.76-29.778-66.56-66.509-66.56V72.71z",
    fill: "#4D7933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.02 151.982c23.525 0 42.595-1.802 42.595-4.025 0-2.223-19.07-4.024-42.595-4.024-23.524 0-42.594 1.801-42.594 4.024s19.07 4.025 42.594 4.025z",
    fill: "#639A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.697 2.227h-18.42V146.62h18.42V2.227z",
    fill: "#756847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.493-70.984c-36.731 0-66.509 29.8-66.509 66.56 0 36.758 29.778 66.559 66.509 66.559v-133.12z",
    fill: "#77AF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5 159c10.77 0 19.5-.895 19.5-2s-8.73-2-19.5-2-19.5.895-19.5 2 8.73 2 19.5 2z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.173 112.301c-.806-1.71-3.07-3.072-5.026-2.731-1.955.341-2.947 2.57-2.598 4.453.321 1.866 2.986 4.177 5.964 3.868 1.976-.251 2.712-3.415 1.66-5.59z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.75 117.461c-.598-1.308-2.195-2.322-3.6-2.056-1.405.266-2.084 1.882-1.819 3.287.266 1.405 2.718 3.079 4.106 2.841 1.378-.283 2.054-2.442 1.313-4.072z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52 118.053c-.026 2.533 1.711 4.603 3.277 4.632 1.538.012 2.307-2.049 2.333-4.583.026-2.533-1.233-3.835-2.771-3.847-1.538-.012-2.813 1.265-2.839 3.798z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.347 118.93c.013.587.564 1.362.989 1.362.425 0 .532-.473.547-1.043-.013-.588-.351-1.15-.776-1.15-.39-.055-.728.233-.76.831z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.159 116.431s.562-1.613 1.824-2.202c1.29-.57 3.726-.452 4.228 1.799 0 0 .198 1.633-1.79 1.721-1.988.089-1.548-.907-2.606-.033-1.029.891-1.843.103-2.055.316l.399-1.601z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.389 153.427c-.037 0-.112 0-.149-.037-.412-.113-.636-.561-.524-.973l1.683-5.421c.112-.411.56-.635.972-.523.411.112.635.561.523.972l-1.682 5.421a.796.796 0 01-.823.561z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.015 152.679s-.935 1.869-.449 2.019c.448.149 7.29 1.906 7.402 1.607.374-1.046-5.009-3.327-5.57-3.327-.598 0-1.234-.561-1.383-.299z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.25 123.421s.561-4.038 1.421-4.561c.897-.524.785 3.364-.748 5.271l-.673-.71z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.282 122.3c.598.299 1.197.598 1.757.86-4.635 9.346-10.019 11.44-19.216 5.72-1.421-.86-1.084-1.309-.411-2.281-.038-.224-.075-.187 0 0 .673-.972 1.159-1.159 2.467-.299 8.562 5.645 10.281 3.253 15.403-4z",
    fill: "#8FCCCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.182 150.263l.112-.224c.262-.336.71-.374 1.084-.187l4.786 2.841c.336.225.523.673.336 1.047a.778.778 0 01-1.122.337l-4.86-2.916c-.299-.15-.448-.561-.336-.898z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.906 152.394c.486-.523 1.01-1.047 1.533-1.57 18.581 10.393 27.067 7.365 6.767-4.337a3.698 3.698 0 01-1.196-5.309c.336-.486.673-.934 1.009-1.42 22.955 15.403 18.992 27.553-8.113 12.636z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.592 151.82a52.577 52.577 0 01-1.795-1.309c10.094-28.6-1.346-16.973-7.664-5.757-.972 1.72-3.402 1.832-4.898.598-.56-.486-1.159-.972-1.719-1.458 15.889-19.366 26.731-22.656 16.076 7.926z",
    fill: "#292B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.491 149.703s-1.757-1.122-1.981-.673c-.225.448-2.73 6.991-2.431 7.14 1.01.486 3.889-4.598 3.963-5.159.075-.598.711-1.159.449-1.308z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.017 144.357c-1.571.635-3.627.523-5.197.075-1.159-.337-3.552-2.057-5.234-1.944l.748-6.393-.262-9.384a3.67 3.67 0 013.664-3.664h1.72a3.67 3.67 0 013.663 3.664l-.261 9.421 1.159 8.225z",
    fill: "#BCF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.508 119.346l2.505-.262c.037.336.299 3.589.187 4.823-.075.374-.711.561-1.384.374-.598-.15-1.046-.524-1.046-.86 0-.711-.15-2.879-.262-4.075zM176.06 140.806s2.58 3.14 2.356 4.149c-.225 1.01-2.991-1.719-3.365-4.149h1.009z",
    fill: "#FFCB13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.835 141.591c-.635.224-1.234.486-1.832.71-3.738-9.758-1.57-15.104 8.861-17.983 1.607-.448 1.682.113 1.981 1.272.224.112.187.074 0 0 .262 1.159.075 1.645-1.458 2.018-9.982 2.393-9.384 5.309-7.552 13.983z",
    fill: "#8FCCCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 199.05,
    y1: 102.564,
    x2: 200.842,
    y2: 0.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F898"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 220.805,
    y1: 145.822,
    x2: 214.748,
    y2: 141.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#949494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 229.504,
    y1: 160.786,
    x2: 229.504,
    y2: 154.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#2C4A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h308v162H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateTreeCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-tree-card.f8560e99ef9a7a394fdc16b731a0208c.svg";